/**
 * Created by zhengyf on 2017/11/29.
 */

; (function () {

    var diaTips = {
        prod: function (badProdNum, badPicNum) {
            return '<div class="advice-content">'
                + '<span>1、您有' + badProdNum + '个问题产品未处理，图片质量不佳' + badPicNum + '个。请您</span>'
                + '<a href="javascript:;" class="advice-blue">立即优化</a>'
                + '</div>';
        },
        shop: function (shopStatus) { // 低于 || 高于
            return '<div class="advice-content">'
                + '<span>1、您的旺铺转化率' + shopStatus + '同行TOP10，优质的旺铺装修，能直观秀出您的企业实力和产品优势，提升您的旺铺转化率，建议您立即</span>'
                + '<a href="javascript:;" class="advice-blue">装修旺铺</a>。攻略：'
                + '<a href="javascript:;" class="advice-blue">旺铺装修教程</a>，'
                + '<a href="javascript:;" class="advice-blue">旺铺装修服务</a>。'
                + '</div>'
                + '<div class="advice-content">'
                + '<span>2、在Home页面展示您的企业概况，能直观秀出您的企业实力，吸引买家眼球，请</span>'
                + '<a href="javascript:;" class="advice-blue">立即设置</a>。教程：'
                + '<a href="javascript:;" class="advice-blue">旺铺公司介绍如何设置</a>。'
                + '</div>'
                + '<div class="advice-content">'
                + '<span>3、一个亮出您企业个性的DIY页面。促销信息，品牌故事，交易流程，想放什么放什么！攻略：</span>'
                + '<a href="javascript:;" class="advice-blue">玩转旺铺的自定义页面</a>'
                + '</div>';
        },
        exposure: function () {
            return '<div class="advice-content">'
                + '<span>1、您的曝光词数低于同行平均，导致您的曝光量偏低，建议您立即</span>'
                + '<a href="javascript:;" class="advice-blue">发布高质量产品</a>'
                + '<span>覆盖更多关键词，获得更多曝光机会。攻略：</span>'
                + '<a href="javascript:;" class="advice-blue">提高曝光量的七大秘籍</a>，'
                + '<a href="javascript:;" class="advice-blue">吸引买家眼球的产品原来是这样的</a>。'
                + '</div>'
                + '<div class="advice-content">'
                + '<span>2、您的P4P曝光词数低于同行TOP10，适当</span>'
                + '<a href="javascript:;" class="advice-blue">添加P4P关键词</a>。'
                + '<span>可以为您带来更多曝光机会。攻略：</span>'
                + '<a href="javascript:;" class="advice-blue">提高P4P询盘转化率的选词技巧</a>，'
                + '<a href="javascript:;" class="advice-blue">P4P出价技巧</a>。'
                + '</div>'
        },
        click: function (score) {
            return '<div class="advice-content">'
                + '<span>1、您的交易等级分为' + score + '，低于同行平均，这会影响您产品的点击率，因为买家对交易等级高的供应商更容易产生信任感，请引导买家线上交易或者走一达通出口都可以提升交易等级。攻略：</span>'
                + '<a href="javascript:;" class="advice-blue">信用保障服务操作指南</a>。'
                + '</div>';
        },
        feedBack: function () {
            return '<div class="advice-content">'
                + '<span>1、您的产品点击率较低导致询盘总量低于同行平均！攻略：</span>'
                + '<a href="javascript:;" class="advice-blue">如何提升点击率？ 如何优化高点击反馈的产品？</a>'
                + '</div>';
        },
        customer: function () {
            return '<div class="advice-content">'
                + '<span>1、您的曝光尚可，但访客较少，表明您的产品展现在搜索列表页时对买家的吸引力不够！请重点优化数据分析中提示您的</span>'
                + '<a href="javascript:;" class="advice-blue">高曝光点击产品</a>。'
                + '<a href="javascript:;" class="advice-blue">攻略：如何提升产品点击量？</a>，'
                + '</div>'
                + '<div class="advice-content">'
                + '<span>2、您的访客发询盘的转化率较低，表明您的产品详情页对买家吸引力不够！请重点优化</span>'
                + '<a href="javascript:;" class="advice-blue">“高点击低反馈”的产品</a>详情页！攻略：'
                + '<a href="javascript:;" class="advice-blue">您真的会写产品描述吗？</a>'
                + '</div>';
        },
        buyer: function () {
            return '<div class="advice-content">'
                + '<span>1、您的TradeManage回复率为0.0%低于同行平均！</span>'
                + '<a href="javascript:;" class="advice-blue">请立即处理未回复消息</a>。TradeManage需要1小时内回复,攻略：'
                + '<a href="javascript:;" class="advice-blue">及时回复率十大注意事项</a>。'
                + '</div>';
        },
        order: function () {
            return '<div class="advice-content">'
                + '<span>1、您的线上订单低于同行平均，完成线上订单（信保、在线批发）可以帮助累积交易等级，获得更多买家青睐！</span>'
                + '<a href="javascript:;" class="advice-blue">交易等级会影响线上排名吗？</a>'
                + '</div>'
                + '<div class="advice-content">'
                + '<span>2、您的订单转化率较低，请注意买家主动发起线上订单，协商一致后即可确认，并引导买家支付。</span>'
                + '<a href="javascript:;" class="advice-blue">立即管理我的线上订单</a>。'
                + '</div>';
        },
        rfq: function () {
            return '<div class="advice-content">'
                + '<span>1、截至报告生成日，您的报价权益还剩1条，建议您挑选合适的买家进行报价获取生意机会，</span>'
                + '<a href="javascript:;" class="advice-blue">立即挑选海量商机</a>。'
                + '</div>'
                + '<div class="advice-content">'
                + '<span>2、您的RFQ报价买家回复数低于同行TOP10，提升报价技能更容易得到买家青睐，RFQ商机中心助你提升报价技能，</span>'
                + '<a href="javascript:;" class="advice-blue">点击了解</a>。攻略：'
                + '<a href="javascript:;" class="advice-blue">RFQ最省心的成单利器</a>'
                + '</div>';
        },
        level: function () {
            return '<div class="advice-content">'
                + '<span>1、您的交易等级分远低于同行，数据分析表明买家更青睐交易等级较高的供应商！较低的交易等级不仅会影响产品的排名，还会影响买家的点击率，请积极引导买家线上交易，线下出口尽量使用一达通，以累计交易等级分。攻略：</span>'
                + '<a href="javascript:;" class="advice-blue">如何快速提升交易等级？</a>'
                + '</div>';
        },
        protection: function () {
            return '<div class="advice-content">'
                + '<span>1、及时发货体现了您的订单履约能力，为避免贸易纠纷，请务必关注！教程：</span>'
                + '<a href="javascript:;" class="advice-blue">信保发货了为什么状态还没变化？信保订单一定要从一达通发货吗？</a>'
                + '</div>';
        }
    };

    angular
        .module('app.core')
        .constant('diaTips', diaTips)

})()
